import { Navigate } from '@tanstack/react-router';
import { useGetUmbracoTafDeliveryApiV1ContentGetMenuSuspense } from '@shared/integrations/umbraco-taf-delivery-api/features/content/content.ts';

const StartPage = () => {
    const { data: menuItems } = useGetUmbracoTafDeliveryApiV1ContentGetMenuSuspense();

    if (menuItems === undefined || menuItems?.length === 0) return null;
    const redirect = menuItems[0].url;

    if (!redirect) return <></>;

    return <Navigate to={redirect} />;
};

export default StartPage;
